/** One image the viewer can display. */
export interface LightboxImage {
  src: string;
  alt?: string;
}

type OpenImageLightboxFn = (images: LightboxImage[], index: number) => void;

let openImageLightboxFn: OpenImageLightboxFn | null = null;

export function setOpenImageLightbox(fn: OpenImageLightboxFn | null) {
  openImageLightboxFn = fn;
}

/** Open the viewer from outside React — ProseMirror plugins, DOM listeners. */
export function openImageLightbox(images: LightboxImage[], index = 0) {
  if (images.length) openImageLightboxFn?.(images, index);
}
